import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import { UserProvider } from './providers/UserProvider';
import { FieldTypeProvider } from './providers/FieldTypeProvider';
import { EntitiesProvider } from './providers/artifacts/EntitiesProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { SearchWrapper } from './components/SearchWrapper';
import { PosthogProvider } from './providers/PosthogProvider';
import { MessageProvider } from './providers/MessageProvider';
import { RootErrorBoundary } from './components/RootErrorBoundary';
import { ContextMenuProvider } from './providers/ContextMenu';

const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement as HTMLElement);

root.render(
  <StrictMode>
    <PosthogProvider>
      <RootErrorBoundary>
        <MessageProvider>
          <UserProvider>
            <FieldTypeProvider>
              <EntitiesProvider>
                <ThemeProvider>
                  <SearchWrapper>
                    <ContextMenuProvider>
                      <App />
                    </ContextMenuProvider>
                  </SearchWrapper>
                </ThemeProvider>
              </EntitiesProvider>
            </FieldTypeProvider>
          </UserProvider>
        </MessageProvider>
      </RootErrorBoundary>
    </PosthogProvider>
  </StrictMode>
);
